// extracted by mini-css-extract-plugin
export default {"wrapper":"absLoader_wrapper__W3UF4","loader":"absLoader_loader__Zt4hk","sm":"absLoader_sm__tAWPh","md":"absLoader_md__fsluP","defaultSize":"absLoader_defaultSize__WOALN"};